import { render, staticRenderFns } from "./formReturn.vue?vue&type=template&id=cec81464&scoped=true"
import script from "./formReturn.vue?vue&type=script&lang=js"
export * from "./formReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec81464",
  null
  
)

export default component.exports